import {Component, ViewChild} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {Page} from "../../orchestration/page";
import {FormComponent} from "../../inputs/form/form.component";
import {NavigationParams} from "../../orchestration/navigation-params";

@Component({
    selector: "woa-marketing-entry-page",
    templateUrl: "./marketing-entry-page.component.html",
    providers: [{provide: Page, useExisting: MarketingEntryPageComponent}]
})
export class MarketingEntryPageComponent extends Page {
    @ViewChild(FormComponent) public form: FormComponent;

    showMobilePhone: boolean;
    showEmail: boolean;
    showPostCode: boolean;
    mobilePhone: string;
    email: string;
    postCode: string;

    constructor(navigationParams: NavigationParams,
                private navigationService: NavigationService) {
        super();
        this.showMobilePhone = navigationParams.get("showMobilePhone");
        this.showEmail = navigationParams.get("showEmail");
        this.showPostCode = navigationParams.get("showPostCode");
    }

    get instructions(): string {
        return this.showMobilePhone && this.showEmail ? "woa.message.marketing.instructions.marketingOptIn.mobilePhoneAndEmail"
            : this.showMobilePhone ? "woa.message.marketing.instructions.marketingOptIn.mobilePhone"
                : this.showEmail ? "woa.message.marketing.instructions.marketingOptIn.email"
                    : "woa.message.marketing.instructions.marketingOptIn.postCode";
    }

    confirmDetails(): void {
        if (!this.form.valid) {
            return;
        }

        // noinspection JSIgnoredPromiseFromCall
        this.navigationService.dismissPage(this, {
            confirmed: true,
            mobilePhone: this.mobilePhone,
            email: this.email,
            postCode: this.postCode
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-info/marketing-entry-page/marketing-entry-page.component.ts